import React, { createContext, useContext } from "react";
import { useParams } from "react-router-dom";
import { useFetchDataDetail } from "@hooks/useFetchDetail";
import { useTranslateInput } from "@hooks/useTranslateInput";
import { ServicesURL } from "@utils/utilsApi";

interface LoTranslationValue {
  languages: any;
  idEntity: string | number;
}

const LoTranslationContext = createContext<LoTranslationValue | null>(null);

interface LoTranslationProviderProps {
  loId?: string | number | null;
  children: React.ReactNode;
}

export const LoTranslationProvider: React.FC<LoTranslationProviderProps> = ({
  loId,
  children,
}) => {
  const { id: corporateId = "" } = useParams();
  const url =
    loId && corporateId
      ? ServicesURL.corporateLanguages.replace(
          ":corporateId",
          String(corporateId),
        )
      : null;

  const { dataDetail: languagesData } = useFetchDataDetail(url);
  const languages = useTranslateInput(languagesData);

  const value: LoTranslationValue | null =
    loId && languages ? { languages, idEntity: loId } : null;

  return (
    <LoTranslationContext.Provider value={value}>
      {children}
    </LoTranslationContext.Provider>
  );
};

export const useLoTranslationContext = () => useContext(LoTranslationContext);

interface TranslationFieldOpts {
  header: string;
  maxValue?: number;
  multiline?: boolean;
  rows?: number;
}

export const useLoTranslationProps = (
  accessorKey: string,
  opts: TranslationFieldOpts,
) => {
  const ctx = useContext(LoTranslationContext);
  if (!ctx || !ctx.languages?.secondary_languages?.length || !ctx.idEntity) {
    return {};
  }
  return {
    languages: ctx.languages,
    idEntity: ctx.idEntity,
    col: {
      entityType: "learning_object",
      accessorKey,
      header: opts.header,
      label: opts.header,
      rules: opts.maxValue ? { max: { value: opts.maxValue } } : undefined,
      multiline: opts.multiline,
      rows: opts.rows,
    },
  };
};
